




































import Vue from 'vue';
import SearchBarComponent from "@/components/search/SearchBarComponent.vue";
import { getConfig } from '@/config';

export default Vue.extend({
  components: {
    SearchBarComponent,
  },
  props: {
    drawer: {
      type: Boolean,
    }
  },
  computed: {
    navDrawer: {
      get: function () {
        return this.drawer;
      },
      set: function (newValue) {
        this.$emit('update:drawer', newValue)
      }
    },
    environmentText() {
      return getConfig().envName || ""
    }
  },

})
